import React from 'react'
import { motion } from 'framer-motion'
import sanitizedContentData from '../../shared/utils/sanitizedContentData'
import DirectionIcon from './icons/DirectionIcon'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'
import PropTypes from 'prop-types'
import { sortBy } from 'lodash'

const BrandsContentComponent = (props) => {
  const { list, current } = props
  const variants = {
    enter: (direction) => {
      return {
        x: direction > 0 ? 100 : -100,
        opacity: 0,
        transition: {
          duration: 1,
          ease: [0.56, 0.03, 0.12, 1.04],
        },
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
      transition: {
        duration: 1,
        ease: [0.56, 0.03, 0.12, 1.04],
      },
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 100 : -100,
        opacity: 0,
      }
    },
  }

  return (
    <InViewSimpleTransition
      className="in-view-container"
      type={'fade'}
      parent={null}
      slide_direction={'right'}
    >
      {list.map((item, index) => {
        // Sorting hotel alphabetically
        const hotelsNames = sortBy(item?.hotels, ['name'])
        return item?.id === current ? (
          <motion.div
            className="brands-container"
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            key={index}
          >
            <div className="content">
              <pre>Why this brand</pre>
              <h2>{item?.name}</h2>
              <div
                className="description"
                dangerouslySetInnerHTML={sanitizedContentData(item?.content)}
              ></div>
              <ul className="brand_hotels">
                {hotelsNames?.map((hotel, index) => (
                  <li key={index}>
                    <span>
                      <DirectionIcon />
                    </span>{' '}
                    {hotel.name}
                  </li>
                )) ?? null}
              </ul>
            </div>
            <div className="brand-image">
              <div className="brand-image-container">
                <img src={item?.image} alt={item?.name ?? ''} />
              </div>
            </div>
          </motion.div>
        ) : null
      })}
    </InViewSimpleTransition>
  )
}

BrandsContentComponent.propTypes = {
  list: PropTypes.array,
  current: PropTypes.any,
}

export default BrandsContentComponent
